import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from './providers.js';
import './app-shell.css';

/**
 * Globale App-Shell: mobile-first, dunkel, untere Tab-Leiste.
 * Die Screens selbst werden Schritt fuer Schritt aus dem eingefrorenen
 * Prototyp migriert – hier steht nur der Rahmen.
 */
const tabs = [
  { to: '/', label: 'Start', end: true },
  { to: '/games', label: 'Spiele', end: false },
  { to: '/search', label: 'Suche', end: false },
  { to: '/profile', label: 'Profil', end: false },
];

export function AppShell() {
  const { status } = useAuth();

  // Solange die bestehende Sitzung geprueft wird, wird weder der Gast-Zustand
  // noch ein Login gezeigt – sonst flackert es bei jedem Reload.
  if (status === 'loading') {
    return (
      <div className="ph-splash" role="status" aria-live="polite">
        PlatHunt
      </div>
    );
  }

  return (
    <div className="ph-shell">
      <main className="ph-shell__content">
        <Outlet />
      </main>
      <nav className="ph-tabbar" aria-label="Hauptnavigation">
        {tabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => `ph-tabbar__item${isActive ? ' is-active' : ''}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
